module.exports = __webpack_public_path__ + "img/vn.75f15ced.svg";